/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Status_SubmittedInputs */



/**
* | output |
* | --- |
* | "Winner's deck submitted to the Tournament Winning Deck Archive (TWDA)." |
*
* @param {Twda_Status_SubmittedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_status_submitted = /** @type {((inputs?: Twda_Status_SubmittedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Status_SubmittedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deck du vainqueur soumis au Tournament Winning Deck Archive (TWDA).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mazo del ganador enviado al Tournament Winning Deck Archive (TWDA).")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Deck do vencedor enviado para o Tournament Winning Deck Archive (TWDA).")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mazzo del vincitore inviato al Tournament Winning Deck Archive (TWDA).")
	return /** @type {LocalizedString} */ ("Winner's deck submitted to the Tournament Winning Deck Archive (TWDA).")
});